var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalisedHeartsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,14.5c-0.5,0-1-0.2-1.4-0.6L3.2,9.1C2.4,8.3,2,7.3,2,6.2C2,5,2.5,4,3.3,3.2c1.7-1.6,4.3-1.6,6-0.1 c1.7-1.6,4.3-1.5,6,0.1c0.7,0.8,1.2,1.9,1.2,3s-0.4,2.2-1.2,3L10.6,14C10.3,14.3,9.8,14.5,9.3,14.5L9.3,14.5z M4.3,4.3 C3.8,4.8,3.5,5.5,3.5,6.2s0.3,1.4,0.8,1.9L9,12.9c0.2,0.2,0.4,0.2,0.6,0l4.7-4.8C14.7,7.6,15,6.9,15,6.2s-0.3-1.4-0.8-1.9 c-1.1-1.1-2.9-1.1-4,0l-1,0.9l-1-0.9C7.2,3.2,5.4,3.2,4.3,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,21.9c-0.4,0-0.8-0.2-1.1-0.5l-3.1-3.1c-1.1-1.2-1.1-3.1,0.1-4.2c1.1-1.1,2.9-1.2,4.1-0.2 c1.2-0.9,3-0.9,4.1,0.2c1.2,1.1,1.2,3,0,4.2l-3.1,3.2C18.3,21.7,18,21.9,17.5,21.9L17.5,21.9z M14.4,15.1c-0.6,0.6-0.6,1.5,0,2.1 l3.1,3.1l3.1-3.1c0.6-0.6,0.6-1.5,0-2.1s-1.6-0.6-2.2,0l-0.8,0.8l-0.8-0.8C16,14.6,15,14.6,14.4,15.1L14.4,15.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalisedHeartsWhite);
export default __webpack_public_path__ + "static/media/personalisedHeartsWhite.23d49022086e9648470e82f2d92142fe.svg";
export { ForwardRef as ReactComponent };